import { FSA } from 'flux-standard-action';
import { assign as _assign } from 'lodash';

import { LocalCountry } from '../models';
import { SelectLanguagePayload, SELECT_LANGUAGE, CLEAR_LANGUAGE } from './localize.action';
import { AvailableLanguages, AvailableLanguagesExtended } from 'franke-trough-dependencies';

export interface AvailableTranslations {
  defaults: {[key: string]: string};
  en: {[key: string]: string};
  de: {[key: string]: string};
  fr: {[key: string]: string};
  cs: {[key: string]: string};
  es: {[key: string]: string};
  it: {[key: string]: string};
  nl: {[key: string]: string};
  pl: {[key: string]: string};
}

export interface AvailableLanguage extends LocalCountry {
  code: AvailableLanguages;
  enabled: boolean;
  extendedCode: AvailableLanguagesExtended;
}

export interface LocalizeLanguageState {
  selected: AvailableLanguagesExtended;
  available: AvailableLanguage[];
}

export interface LocalizeState {
  language: LocalizeLanguageState;
}

const resolveLanguage = (language: AvailableLanguagesExtended): AvailableLanguages | undefined => {
  if (language.indexOf('-') > -1) {
    const langArray = language.split('-');
    return langArray[0] as AvailableLanguages;
  }
  return language as AvailableLanguages;
};

export const availableLanguages: AvailableLanguage[] = [{
  code: 'en',
  enabled: true,
  extendedCode: 'en-150',
  name: 'English'
}, {
  code: 'de',
  enabled: true,
  extendedCode: 'de-DE',
  name: 'Deutsch',
}, {
  code: 'fr',
  enabled: true,
  extendedCode: 'fr-FR',
  name: 'Français'
}, {
  code: 'cs',
  enabled: true,
  extendedCode: 'cs-CS',
  name: 'Čeština'
}, {
  code: 'es',
  enabled: true,
  extendedCode: 'es-ES',
  name: 'Español'
}, {
  code: 'it',
  enabled: true,
  extendedCode: 'it-IT',
  name: 'Italiano'
}, {
  code: 'nl',
  enabled: true,
  extendedCode: 'nl-NL',
  name: 'Nederlands'
}, {
  code: 'pl',
  enabled: true,
  extendedCode: 'pl-PL',
  name: 'Polski'
}];

const isLanguageAvailable = (code: AvailableLanguagesExtended): boolean => {
  let isAvailable: boolean = false;
  availableLanguages.map(lang => {
    if (lang.extendedCode === code) {
      isAvailable = true;
    }
  });
  return isAvailable;
};

const transformLanguageCode = (code: AvailableLanguages): AvailableLanguagesExtended => {
  let extendet: AvailableLanguagesExtended = 'en-150';
  availableLanguages.map(lang => {
    if (lang.code === code) {
      extendet = lang.extendedCode;
    }
  });
  return extendet;
};

export const assignLanguage = (language?: AvailableLanguagesExtended): AvailableLanguagesExtended => {
  const resolvedLanguage = resolveLanguage(language || navigator.language as AvailableLanguagesExtended) || 'en';
  const selected = transformLanguageCode(resolvedLanguage);
  return (isLanguageAvailable(selected) && selected) || 'en-150';
};


export const localizeInitialState: LocalizeState = {
  language: {
    selected: assignLanguage(navigator.language as AvailableLanguagesExtended),
    available: availableLanguages,
  }
};

export const localizeReducer = (
  state: LocalizeState = localizeInitialState, 
  action: FSA<'SELECT_LANGUAGE' | 'CLEAR_LANGUAGE', SelectLanguagePayload>
): LocalizeState => {
  switch (action.type) {

    case SELECT_LANGUAGE:
      return _assign({}, state, {
        language : {
          selected: assignLanguage((action.payload as SelectLanguagePayload).language),
          available: availableLanguages,
        },
      });

    case CLEAR_LANGUAGE: 
      return localizeInitialState;

    default:
      return state;
  }
};